<div class="claim-detail-sidenav">
  <!-- Sticky header: title + close -->
  <div class="sticky-header">
    <div class="header-row">
      <div class="heading text-type-2">
        {{ loadedClaim?.claim_number || (loadedClaim?.title ? loadedClaim.title : 'Claim') }}
      </div>
      <button class="close-btn" (click)="onClose()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Sub-header pill chips: location + date -->
    @if (subHeaderChips.length) {
      <div class="sub-chips-row">
        @for (chip of subHeaderChips; track chip) {
          <div class="sub-chip">{{ chip }}</div>
        }
      </div>
    }

    <!-- Status / severity chips -->
    <div class="chips-row">
      @if (loadedClaim?.status && statusMap[loadedClaim.status]) {
        <div
          [ngClass]="[statusMap[loadedClaim.status].bgColor, statusMap[loadedClaim.status].textColor]"
          class="status-chip px-[10px] rounded-full">
          {{ statusMap[loadedClaim.status].label }}
        </div>
      }
      @if (loadedClaim?.severity && severityMap[loadedClaim.severity]) {
        <div
          [ngClass]="[severityMap[loadedClaim.severity].bgColor, severityMap[loadedClaim.severity].textColor]"
          class="status-chip px-[10px] rounded-full">
          {{ severityMap[loadedClaim.severity].label }}
        </div>
      }
    </div>
  </div>

  <!-- Title as prominent plain text (no label) when claim_number is the heading -->
  @if (loadedClaim?.claim_number && loadedClaim?.title) {
    <div class="claim-title-text">{{ loadedClaim.title }}</div>
  }

  <!-- Description as plain text (no label), matching bid-item style -->
  @if (loadedClaim?.description) {
    <div class="claim-description-text">{{ loadedClaim.description }}</div>
  }

  <!-- Proposed Solution -->
  @if (loadedClaim?.proposed_solution) {
    <div class="section">
      <div class="label">Proposed solution</div>
      <div class="value">{{ loadedClaim.proposed_solution }}</div>
    </div>
  }

  <!-- Need by date -->
  @if (loadedClaim?.need_by_date) {
    <div class="section">
      <div class="label">Need by date</div>
      <div class="value">{{ loadedClaim.need_by_date | date:'MMM d, y' }}</div>
    </div>
  }

  <!-- Media (pictures + attachments) -->
  @if (mediaItems.length) {
    <div class="section">
      <div class="section-head">
        <div class="label">Media</div>
        @if (pictureItems.length) {
          <button class="download-all-btn" (click)="downloadAllPictures()" type="button">
            <mat-icon>download</mat-icon>
            <span>Download all</span>
          </button>
        }
      </div>
      <div class="media-grid">
        @for (picture of mediaItems; track picture.id) {
          <div class="picture-block">
            <app-image
              (click)="appService.openCarousel($event, mediaItems, picture, false)"
              [url]="picture.thumb_url || picture.original_url"
              class="each-picture"
            />
          </div>
        }
      </div>
    </div>
  }

  <!-- Linked Issues -->
  @if (linkedIssuesLoading) {
    <div class="section">
      <div class="label">Linked Issues</div>
      <div class="value muted">Loading...</div>
    </div>
  } @else if (linkedIssues.length) {
    <div class="section">
      <div class="label flex items-center gap-[8px]">
        Linked Issues
        <span class="count-badge">{{ linkedIssues.length }}</span>
      </div>
      <div class="linked-issues-list">
        @for (issue of linkedIssues; track issue.id) {
          <div class="linked-issue-card">
            <div class="linked-issue-header">
              <div class="linked-issue-title">{{ issue.title }}</div>
            </div>
            <div class="linked-issue-meta">
              @if (issue.type) {
                <span class="linked-issue-type-badge">{{ issue.type }}</span>
              }
              @if (issue.status) {
                <span class="linked-issue-status-badge">{{ issueStatusText(issue.status) }}</span>
              }
              <span class="linked-issue-author">
                {{ issue.created_by_first_name }} {{ issue.created_by_last_name }}
              </span>
            </div>
            @if (issue.description) {
              <div class="linked-issue-desc">{{ issue.description }}</div>
            }
            @if (issue.pictures?.length) {
              <div class="media-grid">
                @for (pic of issue.pictures; track pic.id) {
                  <div class="picture-block">
                    <app-image
                      (click)="appService.openCarousel($event, issue.pictures, pic, false)"
                      [url]="pic.thumb_url || pic.original_url"
                      class="each-picture"
                    />
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Footer -->
  <div class="footer">
    <app-primary-button (handleClick)="openFullClaim()" class="w-full">
      Open
    </app-primary-button>
  </div>
</div>
